import React from "react";
import CustomTooltip from "../Tooltip";
import { CheckIcon } from "../Icons";
import CircularLoader from "../CircularLoader";

interface IconButtonProps {
  onClick: () => void;
  tooltipText?: string;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
}

const Index: React.FC<IconButtonProps> = ({
  onClick,
  tooltipText,
  className,
  loading,
  disabled,
  icon,
}) => {
  const isDisabled = disabled || loading;

  const finalIcon =
    icon && React.isValidElement(icon) ? (
      React.cloneElement(icon, {
        size: 16,
        color: isDisabled ? "#F4F5F7" : "#5A8DF1",
      })
    ) : (
      <CheckIcon size={16} color={isDisabled ? "#F4F5F7" : "#5A8DF1"} />
    );

  return (
    <CustomTooltip
      text={tooltipText ?? "Save"}
      className="size-5 "
      position="bottom"
    >
      <button
        className={`${className} rounded-md flex items-center justify-center border border-gray-100 size-5 !p-0  group cursor-pointer hover:bg-gray-100 `}
        onClick={onClick}
        disabled={disabled ?? loading}
      >
        {loading ? <CircularLoader size="sm" /> : finalIcon}
      </button>
    </CustomTooltip>
  );
};

export default Index;
